import { createContext } from 'react';

export interface BreadcrumbContext {
  previousPage: { path: string; label: string } | undefined;
}

export const BreadcrumbContext = createContext<BreadcrumbContext>({
  previousPage: undefined,
});
